import React, { Component } from "react";
import { withRouter } from 'react-router-dom'
import reportsService from '../../../app/service/reportsService';
import AppLayout from "../../../components/layouts/AppLayout";
import { Table, Card, Row, Col } from 'antd';
import { Button } from '../../../components/button';
import { TableSearch } from "../../../hooks";
import { CSVLink } from "react-csv";
import moment from "moment/moment";
class Accesses extends Component {

    /**
     * 
     * Constructor
     */
    constructor(props) {
        super(props);
        this.reportsService = new reportsService();
        this.tableSearch = new TableSearch();
        this.state = {
            loading: false,
            accesses_data: [],
            tablePageSize: 10,
            totalRegisters: 0,
            currentPage: 1
        }
    }

    getAccessesData = () => {
        this.setState({
            loading: true,
        });
        let accesses_data = [];
        this.reportsService.getLogins().then(response => {
            if (response.data.status === 200) {
                response.data.data.map((element, index) => {
                    accesses_data.push({
                        key: index,
                        clientId: element.clientId,
                        clientName: element.clientName,
                        description: element.description,
                        expire: element.expire,
                        lastLogin: element.lastLogin,
                        loginId: element.loginId,
                        telegramChartId: element.telegramChartId,
                        username: element.username
                    });
                })
                this.setState({
                    loading: false,
                    accesses_data: accesses_data,
                    totalRegisters: response.data.data.length
                });
            } else {
                this.setState({
                    loading: false,
                });
            }
        }).catch(error => {
            this.setState({
                loading: false,
            });
        })
    }


    /**
     * Handle Component mounted event and get the Logins from backend
     */
    componentDidMount() {
        this.getAccessesData();
    }

    render() {

        /**
         * Data Columns Headers
         */
        const tableColumns = [
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Usuário</div>
                },
                align: 'center',
                dataIndex: 'username',
                ...this.tableSearch.getColumnSearchProps('username', "Usuário"),
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Cliente</div>
                },
                align: 'center',
                dataIndex: 'clientName',
                ...this.tableSearch.getColumnSearchProps('clientName', "Cliente"),
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Último Acesso</div>
                },
                align: 'center',
                dataIndex: 'lastLogin',
                render: (text) => moment(text).format('HH:mm:ss DD/MM/YYYY'),
                sorter: (a, b) => a.lastLogin.length - b.lastLogin.length,
                sortDirections: ['descend', 'ascend'],
            },
            {
                title: () => {
                    return <div style={{ color: 'white', fontSize: '13px', fontWeight: 500 }}>Expira em</div>
                },
                align: 'center',
                dataIndex: 'expire',
                render: (text) => moment(text).format('HH:mm:ss DD/MM/YYYY'),
                sorter: (a, b) => a.expire.length - b.expire.length,
                sortDirections: ['descend', 'ascend'],
            }
        ];

        /**
         * Pagination Options
         */
        const paginationConfig = {
            defaultPageSize: this.state.tablePageSize,
            total: this.state.totalRegisters,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            onChange: (page, pageSize) => {
                this.setState({
                    tablePageSize: pageSize,
                    currentPage: page
                });
            },
        }
        const paginationTable = this.state.totalRegisters === 0 ? false : paginationConfig;

        return (
            <>
                <AppLayout>
                    <Card title="Acessos" style={{ height: '100%' }} bodyStyle={{ paddingLeft: 5, paddingRight: 5, paddingBottom: 5, paddingTop: 5 }}>
                        <Row>
                            <Col span={24} className="d-flex justify-content-end">
                                <Button
                                    className='successButton'
                                    type='primary'
                                    shape="round"
                                    style={{ width: '150px' }}
                                >
                                    <CSVLink
                                        data={this.state.accesses_data}
                                        separator={";"}
                                        filename={"logins.csv"}
                                    >
                                        Download CSV
                                    </CSVLink>
                                </Button>
                            </Col>
                            <Col span={24} style={{ marginTop: "30px" }}>
                                <Table
                                    style={{ height: '100%' }}
                                    scroll={{ x: "max-content" }}
                                    loading={this.state.loading}
                                    columns={tableColumns}
                                    size='small'
                                    dataSource={this.state.accesses_data}
                                    pagination={paginationTable}
                                    rowClassName={(record, index) => index % 2 === 0 ? 'row-dark ' : 'row-light'}
                                />
                            </Col>
                        </Row>
                    </Card>
                </AppLayout >
            </>
        );
    }
}

export default withRouter(Accesses);